export const roles = {
  admin: ["TOM_MASTER_USER", "TOM_SUPER_USER", "TOM_ADMIN", "TOM_SALES"],
  company: [
    "COMPANY_SUPER_USER",
    "COMPANY_ADMIN",
    "COMPANY_USER",
    "COMPANY_BUSINESS_ACCESS",
  ],
};
